//@flow
import React, { useEffect, useState } from 'react';
import type { VersionType } from 'types/product';
import { FloorPlanMobile } from 'components/molecules/floorPlanMobile';
import { OverlayPortal } from 'components/templates/overlayPortal';
import { OverlayModal } from 'components/templates/overlayModal';
import { useViewport } from 'components/templates/viewportProvider';
import pdfIconWhite from 'assets/images/pdfIconWhite.png';
import './styles.scss';

type Props = {
  versions: Array<VersionType>,
};
export const ProductVersionsMobile = (props: Props) => {
  const { height } = useViewport();
  const { versions, pdfUrl, onDownloadBrochureClick, type } = props;
  const [selectedVersion, setVersion] = useState(versions[0]);
  const [versionsOverlay, setOverlay] = useState(false);
  const productInfo = selectedVersion.product;
  productInfo.version = productInfo.version ? productInfo.version : '';

  return (
    <div className={'version-container-mobile'} style={{ height }}>
      <div className={'mobile-gutter'}>
        {type !== 'Workcations' && ( 
          <h2>Explore Product Model</h2>
        )}
        {pdfUrl && (
          <button
            type={'button'}
            className={'version-pdf-button'}
            onClick={() => window.open(pdfUrl, '_blank')}
          >
            <img src={pdfIconWhite} alt="pdf icon" />
          </button>
        )}
        <h1>
          {productInfo.name}
          <h2 className={'product-version'}>{productInfo.version}</h2>
        </h1>
      </div>
      {type == 'Workcations' && (
        <div className='productDescription'>
          <span
            className={'variations-description'}
            dangerouslySetInnerHTML={{ __html: productInfo.description }}
          />
        </div>
      )}
      {type !== 'Workcations' && (
        <div className={'info mobile-gutter'}>
          <span>{productInfo.bedRooms} BED</span>
          <span>{productInfo.bathRooms} BATH</span>
        </div>
      )}
      <FloorPlanMobile versions={versions} mode={'page'} type={type} />
      {type !== 'Workcations' && ( 
        <span
          className={'more-details'}
          onClick={() => {
            setOverlay(true);
          }}
        >
          MORE DETAILS
        </span>
      )}
      {versionsOverlay && (
        <OverlayPortal>
          <OverlayModal
            data={versions}
            theme={'light-theme'}
            type={'versions-overlay'}
            onClosePress={() => setOverlay(false)}
            breadcrumbList={[
              {
                breadcrumbName: `${productInfo.name}${productInfo.version} Model`,
                breadcrumbLink: '#',
              },
            ]}
          />
        </OverlayPortal>
      )}
    </div>
  );
};
